import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ResourceDirectory } from './components/ResourceDirectory';
import { NewsSection } from './components/NewsSection';
import { EventsCalendar } from './components/EventsCalendar';
import { NextMeeting } from './components/NextMeeting';
import { OfficialResources } from './components/OfficialResources';
import { TranslationProvider } from './components/TranslationProvider';
import { LiveTraffic } from './components/LiveTraffic';
import { WeatherBanner } from './components/WeatherBanner';
import { FloatingContact } from './components/FloatingContact';
import { Facebook, Instagram } from 'lucide-react';
export function App() {
  return <TranslationProvider data-id="element-0">
      <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-sky selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <WeatherBanner data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />

          {/* Directorio Telefónico Digital y Accesible (Reemplaza al libro 3D) */}
          <ResourceDirectory data-id="element-6" />

          <NewsSection data-id="element-7" />
          <LiveTraffic data-id="element-8" />
          <EventsCalendar data-id="element-9" />
          <NextMeeting data-id="element-10" />
          <OfficialResources data-id="element-11" />
        </main>

        <footer className="bg-charcoal-dark text-softblue-dark py-12 text-center text-sm border-t-4 border-sylmar" data-id="element-12">
          <div className="max-w-4xl mx-auto px-6 flex flex-col items-center" data-id="element-13">
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/5Bq82AxSBsu737TAuBSwCc/LOGO_SYLMAR_TRANSPARENTE_2.png" alt="Sylmar Neighborhood Council" className="h-16 brightness-200 notranslate" data-id="element-15" />
            </div>

            {/* Redes Sociales Oficiales */}
            <div className="flex gap-6 mb-8" data-id="element-16">
              <a href="https://www.facebook.com/sylmarnc/" target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] text-white p-3.5 rounded-full hover:scale-110 transition-transform shadow-lg" aria-label="Facebook Oficial" data-id="element-17">
                <Facebook className="w-6 h-6 fill-current" data-id="element-18" />
              </a>
              <a href="https://www.instagram.com/sylmar_nc?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white p-3.5 rounded-full hover:scale-110 transition-transform shadow-lg" aria-label="Instagram Oficial" data-id="element-19">
                <Instagram className="w-6 h-6" data-id="element-20" />
              </a>
            </div>

            <p className="text-gray-400" data-id="element-21">
              © {new Date().getFullYear()}{' '}
              <span className="notranslate" data-id="element-22">Sylmar Neighborhood Council</span>.
              Todos los derechos reservados.
            </p>
          </div>
        </footer>

        {/* Widget Flotante de Contacto */}
        <FloatingContact data-id="element-23" />
      </div>
    </TranslationProvider>;
}